import {
  StyleParamType,
  wixColorParam,
  createStylesParams,
} from '@wix/tpa-settings';
import {
  StyleType,
  CssColor,
  wixColor,
} from '@wix/editor-platform-ooi-metadata-resolver';

type IStylesParams = {
  badgeBGColor: StyleParamType.Color;
  badgeTextColor: StyleParamType.Color;
};

export const badgeStylesParams = createStylesParams<IStylesParams>({
  badgeTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  badgeBGColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
});
